export enum Status {
	Disabled = 1,
	Enabled
}